import { Injectable } from '@angular/core';
import {Observable, tap} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";

const END_POINT = `${environment.SERVICES_URL}`;
const API_KEY = `${environment.API_KEY}`;

@Injectable({
    providedIn: 'root'
})
export class FundingService {
    constructor(private http: HttpClient) {}

    /**
     * consulta para obtener las tarifas por rutas
     */
    getFunding(data: any): Observable<any>{
        const body = JSON.stringify(data);
        const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/funding/getdata`,
            body,
            { headers }
        ).pipe(
            tap(() => {
                this.controlLoader(false);
            })
        );
    }

    /**
     * consulta para obtener los permisos
     */
    add(data: any): Observable<any>{
        const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/funding/create`,
            data,
            { headers }
        ).pipe(
            tap(() => {
                this.controlLoader(false);
            })
        );
    }

    /**
     * consulta para eliminar un registro
     */
    delete(data: any): Observable<any>{
        const body = JSON.stringify(data);
        const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/funding/delete`,
            body,
            { headers }
        ).pipe(
            tap(() => {
                this.controlLoader(false);
            })
        );
    }

    /**
     * consulta para obtener las tarifas por rutas
     */
    getEvents(data: any): Observable<any>{
        const body = JSON.stringify(data);
        const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/funding/getevents`,
            body,
            { headers }
        ).pipe(
            tap(() => {
                this.controlLoader(false);
            })
        );
    }

    /**
     * Función para eliminar un archivo de S3
     */
    deleteS3(name: string): Observable<any>{
        const body = JSON.stringify({name: name});
        const headers = new HttpHeaders().set('X-Api-Key', `${API_KEY}`);
        this.controlLoader(true);
        return this.http.post<any>(
            `${END_POINT}/funding/deleteimage`,
            body,
            { headers }
        ).pipe(
            tap(() => {
                this.controlLoader(false);
            })
        );
    }

    /**
     * Función para mostrar o remover loading
     */
    controlLoader(show:boolean):void{
        // let elemet: any = document.getElementsByClassName("loader-screen")[0];
        // elemet.style.opacity = 0.8;
        // elemet.style.display = elemet.style.display === 'none' ? '' : 'none';
    }


}
